/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { InputChip } from 'components/Fields';

const SoleColor = () => (
  <InputChip type="SOLE_COLOR" name="soleColor" label="Sole color" />
);

export default SoleColor;
